<template>
    <div>
        <DialogoFotosPre ref="dialogoPreFotos" @cargadaFoto="cargaFotoCam" titulo="Foto Carnet"></DialogoFotosPre>
        <v-list>
            <v-list-item-group v-model="selectedItem" mandatory :color="(!hayFotoCarnet) ? 'primary' : 'green'"
                @change="descartaFoto">
                <v-overlay v-model="overlay" :absolute="true">
                    <v-btn color="warning" class="pa-6 elevation-0" @click="onClearFileInput">
                        <v-icon class="mr-2">
                            mdi-delete-outline
                        </v-icon>
                        Actualizar datos guardados
                    </v-btn>
                </v-overlay>
                <v-list-item @click="handleFileImport">
                    <v-list-item-icon>
                        <input ref="uploader" class="d-none" type="file" accept="image/jpeg,image/jpg,image/png"
                            @change="onFileChanged">
                        <v-icon>mdi-folder-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>SUBIR ARCHIVO</v-list-item-title>
                    </v-list-item-content>
                    <canvas id="canvas" width="600" height="600" ref="cv" style="display: none"></canvas>
                    <v-list-item-action>
                        <v-icon v-if="selectedItem == 0 && hayFotoCarnet">mdi-check-circle</v-icon>
                        <v-icon v-if="!hayFotoCarnet">mdi-arrow-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item @click="lanzarDialogFoto" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-list-item-icon>
                        <v-icon>mdi-webcam</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>TOMAR FOTO</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon v-if="selectedItem == 1 && hayFotoCarnet">mdi-check-circle</v-icon>
                        <v-icon v-if="!hayFotoCarnet">mdi-arrow-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex'
import InputButton from '@/components/inputs/InputButton.vue'
import CameraCanvas from '@/components/inputs/CameraCanvas.vue'
import DialogoFotosPre from '@/components/dialogos/DialogoFotosPre.vue'


export default {
    components: {
        InputButton,
        CameraCanvas,
        DialogoFotosPre,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            // subir archivos
            file: null,
            selectedFile: null,
            selectedFileName: '',
            activeCamera: false,
            //data select
            selectedItem: null,
            overlay: false
        }
    },
    computed: {
        ...mapGetters('preafiliacion', ['fototmp', 'preafi', 'hayFotoCarnet', 'fotocarnet']),

    },

    methods: {
        ...mapActions('preafiliacion', ['addFotoCarnet', 'deleteFotoCarnet']),
        ...mapActions('notificaciones', ['showSnack']),

        descartaFoto() {
            this.addFotoCarnet('')

        },

        cargaFotoCam(value) {
            this.overlay = true
            console.log(value)
            // emite a ExpansionPanelGen
            this.$emit('isCorrectForm', { valid: true, index: this.index })
        },


        /*  Metodos para 'subir archivo' */
        handleFileImport() {
            // Trigger click on the FileInput
            try {
                this.$refs.uploader.click();
            } catch (error) {
                console.log('error: ' + error)
            }
        },
        onFileChanged(e) {
            this.selectedFile = ''
            if (e.target.files[0]) {
                this.selectedFile = e.target.files[0]
                console.log(e.target.files[0])
                this.selectedFileName = e.target.files[0].name
                //this.precargaFoto(this.selectedFile)

                //envio señal de fotoSeleccionada
                //this.$emit('haySeleccion')
                const reader = new FileReader();
                reader.onloadend = () => {
                    //referencia al elemento canvas
                    let canvas = this.$refs.cv
                    //config
                    const ctx = canvas.getContext("2d");
                    //nueva imagen
                    const img = new Image
                    img.src = URL.createObjectURL(this.selectedFile)
                    img.onload = function () {
                        var hRatio = canvas.width / img.naturalWidth
                        var vRatio = canvas.height / img.naturalHeight
                        var ratio = Math.min(hRatio, vRatio)
                        var centerX = (canvas.width - img.width * ratio) / 2

                        //REVISAR: aca esta el problema, esta dando 0
                        var centerY = (canvas.height - img.height * ratio) / 2

                        ctx.clearRect(0, 0, canvas.width, canvas.height)

                        //ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
                        ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);

                    }
                    let dataURL = canvas.toDataURL('image/png');
                    console.log(dataURL)
                    const arr = dataURL.split(',');
                    console.log(dataURL)
                    this.addFotoCarnet(arr[1])
                    this.showSnack({
                        message: 'Archivo guardado correctamente',
                        type: '200'
                    })
                };
                reader.readAsDataURL(this.selectedFile)
                this.overlay = true
                // emite a ExpansionPanelGen
                this.$emit('isCorrectForm', { valid: true, index: this.index })
            }
        },
        /*  Fin metodos 'subir archivo' */

        changedValue() {
            this.selectedItem = -1
        },
        onClearFileInput() {
            this.deleteFotoCarnet()
            this.overlay = false
        },

        /* Metodos para 'tomar foto' */
        lanzarDialogFoto() {
            this.$refs.dialogoPreFotos.abrirDialogo()
        }
        /* Fin metodos 'tomar foto' */

    },
    props: ['index'],

}


</script>